import { inject, Injectable } from '@angular/core';
import { STORAGE_KEY } from '../../providers/storage-key/storage-key.token';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    #storageKey = inject(STORAGE_KEY, { optional: true }) ?? '';

    createLocalStorage = <T, K extends string>(key: K, defaultValue: T) =>
        new LocalStorageService(this.#storageKey, key, defaultValue);
}
